import { useCallback, useState } from "react";
import { VoiceProfileResponse } from "../types";

export const useVoicePreviewPlayback = () => {
  const [voice, setVoice] = useState<VoiceProfileResponse>();
  const [playingCardId, setPlayingCardId] = useState<string | null>(null);

  const getVoiceForCard = useCallback(
    (cardId: string) => (playingCardId === cardId ? voice : undefined),
    [playingCardId, voice]
  );

  const handleVoiceChange = useCallback(
    (cardId: string) => (next?: VoiceProfileResponse) => {
      setVoice(next);
      setPlayingCardId(next ? cardId : null);
    },
    []
  );

  return { getVoiceForCard, handleVoiceChange };
};
